"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _enviro = _interopRequireDefault(require("enviro"));

var _Dom = require("UIComponents/utils/Dom");

var cancelDragEvent = function cancelDragEvent(e) {
  e.preventDefault();
  e.stopPropagation();
};

var isDebug = function isDebug() {
  return _enviro.default.debug('filedrop');
};

var logDebug = function logDebug() {
  if (isDebug()) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    console.log.apply(console, ['[FileDragAndDrop]'].concat(args));
  }
};

var matchesSelector = function matchesSelector(el, className) {
  if (el instanceof SVGElement) {
    return false;
  }

  return (0, _Dom.matches)(el, className);
};

var matchesOrWithinSelector = function matchesOrWithinSelector(el, className) {
  if (matchesSelector(el, className)) {
    return true;
  }

  while (el && el.parentElement) {
    if (matchesSelector(el.parentElement, className)) {
      return true;
    }

    el = el.parentElement;
  }

  return false;
};

var FileDragAndDrop = function FileDragAndDrop(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      ignoreTargetSelector = _ref.ignoreTargetSelector,
      onDropFiles = _ref.onDropFiles;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOver = _useState2[0],
      setIsOver = _useState2[1];

  var isOverRef = (0, _react.useRef)(null);
  var onDragEnter = (0, _react.useCallback)(function (e) {
    if (ignoreTargetSelector && matchesOrWithinSelector(e.target, ignoreTargetSelector)) {
      logDebug('ignoring onDragEnter on target to parent classname', e.target, ignoreTargetSelector);
      return;
    } else {
      logDebug('onDragEnter', e.target);
    }

    e.preventDefault();
    isOverRef.current = e.target;
    setIsOver(true);
  }, [ignoreTargetSelector]);
  var onDragOver = (0, _react.useCallback)(function (e) {
    cancelDragEvent(e);
  }, []);
  var onDragLeave = (0, _react.useCallback)(function (e) {
    if (isOverRef.current === e.target) {
      isOverRef.current = null;
      setIsOver(false);
    }
  }, []);
  var onDrop = (0, _react.useCallback)(function (e) {
    if (ignoreTargetSelector && matchesOrWithinSelector(e.target, ignoreTargetSelector)) {
      logDebug('ignoring onDrop on target to parent classname', e.target, ignoreTargetSelector);
      return;
    } else {
      if (isDebug()) {
        e.persist();
        logDebug('onDrop', e);
      }
    }

    var files = e.dataTransfer ? e.dataTransfer.files : [];

    if (files && files.length) {
      e.preventDefault();
      onDropFiles((0, _toConsumableArray2.default)(files));
      setIsOver(false);
    }
  }, [ignoreTargetSelector, onDropFiles]);

  if (disabled) {
    return children({
      isOver: false,
      onDragOver: cancelDragEvent,
      onDrop: cancelDragEvent
    });
  }

  return children({
    isOver: isOver,
    onDrop: onDrop,
    onDragEnter: onDragEnter,
    onDragOver: onDragOver,
    onDragLeave: onDragLeave
  });
};

FileDragAndDrop.propTypes = {
  children: _propTypes.default.func.isRequired,
  onDropFiles: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  ignoreTargetSelector: _propTypes.default.string
};
FileDragAndDrop.defaultProps = {
  disabled: false
};
var _default = FileDragAndDrop;
exports.default = _default;
module.exports = exports.default;